/* eslint-disable quote-props */
/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const articleSchema = (articleInfo, url) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "headline": articleInfo?.title,
    "description": articleInfo?.metaDescription,
    "image": "blog image",
    "author": {
      "@type": "Organization",
      "name": "Wealthy",
      "url": "https://www.wealthy.in/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Wealthy",
      "logo": {
        "@type": "ImageObject",
        "url": ""
      }
    },
    "datePublished": articleInfo?.publishedAt,
    "dateModified": articleInfo?.updatedAt
  };

  return schema;
};

export default articleSchema;
